import React, { useEffect } from 'react'
import Header from 'components/Header'
import Footer from 'components/Footer'
import { Check } from 'lucide-react'

function ServiceLayout({ title, eyebrow, subtitle, intro, blocks, steps, ctaText, pageTitle }) {
  useEffect(() => {
    document.title = pageTitle
    window.scrollTo(0, 0)
  }, [pageTitle])

  const whatsappHref = `https://api.whatsapp.com/send?phone=554396659096&text=${encodeURIComponent(
    `Olá, vim pelo site e ${ctaText.toLowerCase()}!`,
  )}`

  return (
    <main className='relative w-full bg-dorac-bg font-display text-dorac-ink'>
      <Header />

      <section className='dorac-grid-bg flex items-center pb-12 pt-28 md:min-h-[80vh] md:pb-16 md:pt-32'>
        <div className='container mx-auto max-w-3xl px-4 text-center'>
          <span className='section-eyebrow'>{eyebrow}</span>
          <h1 className='section-title mb-6'>{title}</h1>
          <p className='section-subtitle mx-auto mb-8'>{subtitle}</p>
          <a href={whatsappHref} target='_blank' rel='noopener noreferrer' className='btn-dorac gap-2 px-8 py-4'>
            {ctaText}
          </a>
        </div>
      </section>

      <section className='bg-white py-24'>
        <div className='container mx-auto max-w-4xl px-4 text-center'>
          <p className='text-base leading-relaxed text-dorac-ink/70 md:text-lg'>{intro}</p>
        </div>
      </section>

      <section className='dorac-grid-bg py-24'>
        <div className='container mx-auto px-4'>
          <div className='mb-16 text-center'>
            <h2 className='section-title'>O que nós te entregamos</h2>
          </div>
          <div className='mx-auto grid max-w-6xl grid-cols-1 gap-6 md:grid-cols-3'>
            {blocks.map((block) => (
              <div key={block.title} className='card-dorac flex flex-col'>
                <h3 className='mb-2 text-xl font-bold text-dorac-purple'>{block.title}</h3>
                <p className='mb-4 text-sm leading-relaxed text-dorac-ink/60'>{block.desc}</p>
                <ul className='mt-auto space-y-2'>
                  {block.items.map((item) => (
                    <li key={item} className='flex items-start gap-2 text-sm text-dorac-ink/70'>
                      <Check className='mt-0.5 h-4 w-4 flex-shrink-0 text-dorac-purple' />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className='dorac-grid-bg-dark py-24 text-white'>
        <div className='container mx-auto px-4'>
          <div className='mx-auto mb-16 max-w-2xl text-center'>
            <h2 className='text-3xl font-bold md:text-4xl'>Etapas do processo</h2>
          </div>

          <div className='mx-auto grid max-w-5xl grid-cols-1 gap-8 md:grid-cols-4'>
            {steps.map((step, index) => (
              <div key={step.title} className='text-center'>
                <div
                  className='mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full text-lg font-black'
                  style={{ background: 'rgba(255,233,140,0.15)', color: '#FFE98C' }}
                >
                  {String(index + 1).padStart(2, '0')}
                </div>
                <h3 className='mb-2 text-lg font-bold'>{step.title}</h3>
                <p className='text-sm leading-relaxed text-white/60'>{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className='dorac-grid-bg py-24'>
        <div className='container mx-auto max-w-2xl px-4 text-center'>
          <h2 className='section-title mb-6'>Pronto para começar?</h2>
          <p className='section-subtitle mx-auto mb-8'>
            Agende um diagnóstico estratégico gratuito e descubra como podemos alavancar o seu negocio.
          </p>
          <a href={whatsappHref} target='_blank' rel='noopener noreferrer' className='btn-dorac px-8 py-4'>
            Agendar!
          </a>
        </div>
      </section>

      <Footer />
    </main>
  )
}

export default ServiceLayout
